import type { Country } from '@eti/schema-types';
import type { CountryOption, TransformedPaymentMethod } from '../models';
import { addressFields, ADDRESS_FORM_SECTION, reduxFields } from '../constants/formFields';
import { paymentMethodCodes, paymentMethodTypes } from '../constants/paymentMethods';

const { STREET, ZIP_CODE, CITY, COUNTRY, CARE_OF, HOUSE_NUMBER } = addressFields;
const { SELECTED_PAYMENT_METHOD } = reduxFields;

const getDefaultCountryForMarket = (market: Country, countries: CountryOption[]) => {
  const defaultCountry = countries?.find((country) => market.name === country?.label);

  return defaultCountry?.value ?? null;
};

export const getInitialFormValuesForAddressFormSection = (
  market: Country,
  countries: CountryOption[],
) => {
  const country = getDefaultCountryForMarket(market, countries);

  return {
    [ADDRESS_FORM_SECTION]: {
      [STREET]: '',
      [HOUSE_NUMBER]: '',
      [CITY]: '',
      [ZIP_CODE]: '',
      [COUNTRY]: country,
      [CARE_OF]: '',
    },
  };
};

export const setMethodInitialValues = (
  methods: TransformedPaymentMethod[],
  isFirstPaymentMethodOpen: boolean = false,
) => {
  if (!isFirstPaymentMethodOpen && methods.length > 1) {
    return null;
  }
  const [defaultMethod] = methods;

  if (
    defaultMethod.type === paymentMethodTypes.WALLET &&
    defaultMethod.code !== paymentMethodCodes.UPI &&
    defaultMethod.code !== paymentMethodCodes.APP_CARD
  ) {
    return {
      [SELECTED_PAYMENT_METHOD]: {
        code: defaultMethod.code,
        type: defaultMethod.type,
        id: defaultMethod.id,
        price: defaultMethod.price.value,
      },
    };
  }

  return {
    [SELECTED_PAYMENT_METHOD]: {
      code: defaultMethod.code,
      type: defaultMethod.type,
    },
  };
};
